module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_SendToBack_16"],"path":[{"$":{"d":"M6,14H8v1H5V12H6Zm8,0H12v1h3V12H14Zm0-3h1V9H14ZM12,5V6h2V8h1V5ZM9,15h2V14H9ZM10,1H1v9H5v1H6V6h5V5H10Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_SendToBack_16.svg
// module id = iWg8
// module chunks = 1